'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var common = {
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden'
};
var appear = exports.appear = function appear(rect) {
  return _extends({}, common, {
    perspective: rect.height,
    rotateY: -180,
    opacity: 0
  });
};

var appeared = exports.appeared = function appeared() {
  return _extends({}, common, {
    perspective: 0,
    rotateY: 0,
    opacity: 1
  });
};

var enter = exports.enter = appeared;

var entered = exports.entered = appeared;

var leaved = exports.leaved = function leaved(rect) {
  return _extends({}, common, {
    perspective: rect.height,
    rotateY: 180,
    opacity: 0
  });
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(common, 'common', 'src/animations/transitions/helix.js');

  __REACT_HOT_LOADER__.register(appear, 'appear', 'src/animations/transitions/helix.js');

  __REACT_HOT_LOADER__.register(appeared, 'appeared', 'src/animations/transitions/helix.js');

  __REACT_HOT_LOADER__.register(enter, 'enter', 'src/animations/transitions/helix.js');

  __REACT_HOT_LOADER__.register(entered, 'entered', 'src/animations/transitions/helix.js');

  __REACT_HOT_LOADER__.register(leaved, 'leaved', 'src/animations/transitions/helix.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/react-stack-grid/lib/animations/transitions/helix.js
// module id = 811
// module chunks = 73261030922168